/**
 * @generated SignedSource<<dc4e447dd4c549c74e9450442a09d283>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportHubDetailedSkillReportByStandardsRowsQuery$variables = {
  classIds: ReadonlyArray<string>;
  skip?: boolean | null | undefined;
  standardStateId: string;
  targetGroupId: string;
};
export type ReportHubDetailedSkillReportByStandardsRowsQuery$data = {
  readonly transposedSkillProgressReportGroupedByStandardsInBytes?: {
    readonly data: ReadonlyArray<any>;
  };
};
export type ReportHubDetailedSkillReportByStandardsRowsQuery = {
  response: ReportHubDetailedSkillReportByStandardsRowsQuery$data;
  variables: ReportHubDetailedSkillReportByStandardsRowsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classIds"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "standardStateId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetGroupId"
},
v4 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "classIds",
            "variableName": "classIds"
          },
          {
            "kind": "Variable",
            "name": "standardStateId",
            "variableName": "standardStateId"
          },
          {
            "kind": "Variable",
            "name": "targetGroupId",
            "variableName": "targetGroupId"
          }
        ],
        "concreteType": "ExportableReport",
        "kind": "LinkedField",
        "name": "transposedSkillProgressReportGroupedByStandardsInBytes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubDetailedSkillReportByStandardsRowsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportHubDetailedSkillReportByStandardsRowsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "ae55cfe20ead96ea2bf413d44859ea25",
    "id": null,
    "metadata": {},
    "name": "ReportHubDetailedSkillReportByStandardsRowsQuery",
    "operationKind": "query",
    "text": "query ReportHubDetailedSkillReportByStandardsRowsQuery(\n  $classIds: [ID!]!\n  $standardStateId: ID!\n  $targetGroupId: ID!\n  $skip: Boolean = true\n) {\n  transposedSkillProgressReportGroupedByStandardsInBytes(classIds: $classIds, standardStateId: $standardStateId, targetGroupId: $targetGroupId) @skip(if: $skip) {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf90150287de69ad5565922787acd506";

export default node;
